export default function expandedReducer(state = false, action) {
  switch (action.type) {
    case 'SET_EXPANDED':
      return action.payload
    default:
      return state
  }
}
